import React from 'react';
import icon from '../../../../assets/profile/blank-profile-picture.png';

const IconProfile = () => (
    <div>
        <img style = {{height: 25, borderRadius: '50%'}} src={icon} alt="user-icon"/>
    </div>
);
export default IconProfile;